export enum AssignableOrganizationType {
  AllOrganizations = 0,
  OnlySalesAgencies = 1,
  OnlyDistributors = 2,
}
